
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

// Create an instance of axios with default settings
const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

// Add a request interceptor to include the token in the headers
axiosInstance.interceptors.request.use(
  (config) => {
  const token = localStorage.getItem('userToken');
    if (token) {
      config.headers["x-access-token"] = token; // Set the token in the header
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


export const getOrganizations = async (payload) => {
  try {
    const response = await axiosInstance.post("/getOrganizations",payload);
    return response.data;
  } catch (error) {
    console.error("getOrganizations API Error:", error);
    throw error;
  }
};

export const followOrganization = async (payload) => {
  try {
    const response = await axiosInstance.post("/followOrganization",payload);
    return response.data;
  } catch (error) {
    console.error("followOrganization API Error:", error);
    throw error;
  }
};
export const unfollowOrganization = async (payload) => {
  try {
    const response = await axiosInstance.post("/unfollowOrganization",payload);
    return response.data;
  } catch (error) {
    console.error("unfollowOrganization API Error:", error);
    throw error;
  }
};
export const getUserFollowingOrganizations = async (payload) => {
  try {
    const response = await axiosInstance.post("/getUserFollowingOrganizations",payload);
    return response.data;
  } catch (error) {
    console.error("getUserFollowingOrganizations API Error:", error);
    throw error;
  }
};
export const editOrganizationDetails = async (payload) => {
  try {
    const response = await axiosInstance.post("/editOrganizationDetails",payload);
    return response.data;
  } catch (error) {
    console.error("editOrganizationDetails API Error:", error);
    throw error;
  }
};


export const listOrganizationPosts = async (payload) => {
  try {
    const response = await axiosInstance.post("/listOrganizationPosts",payload);
    return response.data;
  } catch (error) {
    console.error("listOrganizationPosts API Error:", error);
    throw error;
  }
};


export const getOrganizationCommunities = async (payload) => {
  try {
    const response = await axiosInstance.post("/getOrganizationCommunities",payload);
    return response.data;
  } catch (error) {
    console.error("getOrganizationCommunities API Error:", error);
    throw error;
  }
};

export const getUserCommunitySearch = async (payload) => {
  try {
    const response = await axiosInstance.post("/getUserCommunitySearch",payload);
    return response.data;
  } catch (error) {
    console.error("getUserCommunitySearch API Error:", error);
    throw error;
  }
};

export const getOrganizationSearch = async (payload) => {
  try {
    const response = await axiosInstance.post("/getOrganizationSearch",payload);
    return response.data;
  } catch (error) {
    console.error("getOrganizationSearch API Error:", error);
    throw error;
  }
};











